import { render, staticRenderFns } from "./KPIsComponent.vue?vue&type=template&id=39a6c10a&scoped=true"
import script from "./KPIsComponent.vue?vue&type=script&lang=js"
export * from "./KPIsComponent.vue?vue&type=script&lang=js"
import style0 from "./KPIsComponent.vue?vue&type=style&index=0&id=39a6c10a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a6c10a",
  null
  
)

export default component.exports